import GmailFiltersGrid from './gmail-filters-grid';

export default function GmailFiltersPage() {
  return <GmailFiltersGrid />;
}
